import { MessageHandlerAction } from "@escid-esp/applicationshell/message-broker/MessageHandlerAction";
import {
    KrakenBaseEvent,
    KrakenRecommendationViewedEvent,
    KrakenSuggestionEvent,
    SearchFragmentName
} from "../../types/kraken";
import { SearchboxViewType } from "../../types/searchbox";

let isKrakenReady = false;
let hasSubscribedToBroker = false;

/**
 * If events are produced before the Kraken is ready, ShopSearchWeb will drop undeliverable events.
 */
export function subscribeToKrakenReady(): void {
    if (hasSubscribedToBroker) return;
    hasSubscribedToBroker = true;

    const handleKrakenReady: MessageHandlerAction = (payload: unknown) => {
        if (typeof payload === "boolean" && payload) {
            isKrakenReady = true;
        }
    };
    shell?.messageBroker.once("kraken.rdy", handleKrakenReady, "ESPP2.ShopSearchWeb");
}

export function sendSuggestionsEventToKraken(searchTerm: string): void {
    if (!isKrakenReady) return;
    const eventData = createKrakenEvent<KrakenSuggestionEvent>("SearchSuggestions", { searchTerm });
    shell?.messageBroker.publishTo("kraken.searchsuggestions", eventData);
}

export function sendRecommendationEventToKraken(recoProps: KrakenRecommendationViewedEvent): void {
    if (!isKrakenReady) return;
    const eventData = createKrakenEvent<KrakenRecommendationViewedEvent>("RecommendationViewed", {
        ...recoProps
    });
    shell?.messageBroker.publishTo("kraken.recommendationviewed", eventData);
}

export function mapViewToKrakenFragmentName(view: SearchboxViewType): SearchFragmentName {
    switch (view) {
        case "wide":
            return SearchFragmentName.SearchBoxHeaderTop;
        case "flyout":
            return SearchFragmentName.SearchBoxHeaderFlyout;
        case "grid":
            return SearchFragmentName.SearchBoxSearchResultPage;
        case "megamenu":
            return SearchFragmentName.SearchBoxMegaMenu;
        default:
            return SearchFragmentName.SearchBox;
    }
}

function createKrakenEvent<T>(type: string, properties: T): KrakenBaseEvent<T> {
    return {
        version: 1,
        eventDate: new Date().toISOString(),
        eventId: crypto.randomUUID(),
        context: { senderId: "ESPP2.ShopSearchWeb" },
        type,
        properties
    };
}
